import { render, staticRenderFns } from "./groupTaskApproved.vue?vue&type=template&id=593761ca&"
import script from "./groupTaskApproved.vue?vue&type=script&lang=js&"
export * from "./groupTaskApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports